import React, { createContext, useContext, useCallback } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const AuxiliariesContext = createContext();

export function useAuxiliaries() { return useContext(AuxiliariesContext); }

const normalizeSearchText = (value) => {
  if (!value) return '';
  return value
    .toString()
    .trim()
    .replace(/\s+/g, ' ');
};

const capitalizeSearchText = (value) => {
  const normalized = normalizeSearchText(value);
  if (!normalized) return '';
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

export function AuxiliariesProvider({ children }) {
  const accessToken = localStorage.getItem('accessToken');
  // Requisição Listar Countrys
  const listCountry = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/country/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar países', error);
      toast.error('Erro ao buscar países');
    }
  };

  // Requisição Listar State
  const listState = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/state/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar estado', error);
      toast.error('Erro ao buscar estados');
    }
  };

  // Requisição Listar City
  const listCity = async (params = {}) => {
    const accessToken = localStorage.getItem('accessToken');

    const headers = {};
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    try {
      const response = await api.get('auxiliaries/city/', {
        headers,
        params,
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar cidade', error);
      toast.error('Erro ao buscar cidades');
    }
  };

  // Listar tipos de files
  const listTypeFiles = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/internals/typefile/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar Type files', error);
      toast.error('Erro ao buscar tipos de documentos');
    }
  };

  // Listar status de interno
  const listInternalStatus = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/internals/internalstatus/', {
        params: { limit: 100 },
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar status de interno', error);
      toast.error('Erro ao buscar status de interno');
    }
  };

  // Listar tipos de religioes
  const listReligions = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/religion/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar religions', error);
      toast.error('Erro ao buscar religions');
    }
  };

  // Listar tipos de profissoes
  const listProfessions = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/profession/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar profissões', error);
      toast.error('Erro ao buscar profissões');
    }
  };
  // Listar tipos de vistas
  const listTypeVisits = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typevisit/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipos de vistas', error);
      toast.error('Erro ao buscar tipos de visitas');
    }
  };
  // Listar tipos de vistas outros
  const listTypeVisitors = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typevisitor/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipos de vistas', error);
      toast.error('Erro ao buscar tipos de visitas');
    }
  };

  // Listar programas sociais
  const listSocialProgram = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('internals/internalsocialprogram/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar programa social', error);
      toast.error('Erro ao buscar programa social');
    }
  };

  // Listar familia programas sociais
  const listFamilySocialProgram = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('internals/familysocialprogram/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar familia programa social', error);
      toast.error('Erro ao buscar familia programa social');
    }
  };

  // Listar disturbios mentais
  const listMentalDisorders = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/mentaldisorder/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar distúrbios mentais', error);
      toast.error('Erro ao buscar distúrbios mentais');
    }
  };

  // Listar drogas
  const listDrugs = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/drugs/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar drogas', error);
      toast.error('Erro ao buscar drogas');
    }
  };

  // Listar cor ou etinia
  const listColorEthnicity = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/color_ethnicity/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar cor/etinia', error);
      toast.error('Erro ao buscar cor/etinia');
    }
  };

  // Listar genero
  const listGender = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/gender/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar genero', error);
      toast.error('Erro ao buscar genero');
    }
  };

  const listScholarity = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/scholarity/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar escolaridade', error);
      toast.error('Erro ao buscar escolaridade');
    }
  };

  // Listar oriantação sexual
  const listSexualOrientation = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/sexualorientation/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar orientação sexual', error);
      toast.error('Erro ao buscar orientação sexual');
    }
  };

  // Listar estado sivil
  const listMaritalStatus = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/marital_status/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar cor/etinia', error);
      toast.error('Erro ao buscar cor/etinia');
    }
  };

  // Listar diagnostico
  const listDiagnoses = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/diagnosis/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar diagnósticos', error);
      toast.error('Erro ao buscar diagnósticos');
    }
  };

  // Listar Alegias
  const listAllergies = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/allergy/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar alergias', error);
      toast.error('Erro ao buscar alergias');
    }
  };

  // Listar aparelhos ou drenos
  const listDevicesOrDrains = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/devicesordrains/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar aparelho/drenos', error);
      toast.error('Erro ao buscar aparelho/drenos');
    }
  };

  // Listar infecções sexuais
  const listSexualInfections = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/sexualinfection/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar infecções sexuais', error);
      toast.error('Erro ao buscar infecções sexuais');
    }
  };

  // Listar dentição
  const listDentitions = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/dentition/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar dentição', error);
      toast.error('Erro ao buscar dentição');
    }
  };

  // Função para listar as vacinas disponíveis
  const listVaccinations = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      // Ajuste a URL conforme a sua API; o exemplo abaixo supõe que o endpoint é "auxiliaries/vaccinations/"
      const response = await api.get('auxiliaries/vaccination/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar vacinas', error);
      toast.error('Erro ao buscar vacinas');
      return [];
    }
  };

  // Função para listar os remédios disponíveis
  const listRemedies = async (params = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      const response = await api.get('auxiliaries/remedy/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar remédios', error);
      toast.error('Erro ao buscar remédios');
      return [];
    }
  };

  const createRemedy = async (name) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.post('auxiliaries/remedy/', { name }, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      toast.success('Medicamento cadastrado com sucesso');
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar medicamento', error);
      toast.error('Erro ao cadastrar medicamento');
    }
  };

  // Listar procedimentos odontologycos
  const listProcedures = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/procedure/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar dentição', error);
      toast.error('Erro ao buscar dentição');
    }
  };

  // Listar procedimentos problemas de visao
  const listVisionProblems = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/visionproblem/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar problemas de visão', error);
      toast.error('Erro ao buscar problemas de visão');
    }
  };

  // Listar tipos de agendamento
  const listScheduling = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typescheduling/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      toast.error('Erro ao buscar agendamentos');
    }
  };

  const getSchedulingById = async (id) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return null;
    try {
      const response = await api.get(`/internals/scheduling/${id}/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data;
    } catch {
      return null;
    }
  };

  // Tipo de relação com interno
  const listTypeRelationInternal = async () => {
    try {
      const response = await api.get('auxiliaries/familyrelationship/')

      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar relação com interno', error);
      toast.error('Erro ao buscar relação com interno');
    }
  };

  // Tipo tipo de isitante
  const listTypeVisitor = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typevisitor/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data.results;
    } catch (error) {
      console.log('Erro ao buscar tipo de visitante', error);
      toast.error('Erro ao buscar tipo de visitante');
    }
  };

  // Tipo tipo de atendimento
  const listTypeservicecare = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typeservicecare/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipo de serviso de saude', error);
      toast.error('Erro ao buscar tipo de serviso de saude');
    }
  };

  // Tipo tipo de exame
  const listTypeExam = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typeexam/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipo de exames', error);
      toast.error('Erro ao buscar tipo de exames');
    }
  };

  // Tipo de teste
  const listTypeTest = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/typetest/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipo de teste', error);
      toast.error('Erro ao buscar tipo de teste');
    }
  };

  // Tipos de empresas
  const listInstitutions = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/institution/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar instituições', error);
      toast.error('Erro ao buscar instituições');
    }
  };

  const createInstitution = useCallback(async (data) => {
    try {
      const response = await api.post('auxiliaries/institution/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Instituição cadastrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar instituição:', error);
      toast.error('Erro ao criar instituição');
    }
  }, [accessToken]);

  // Tipods de servicos actives
  const listActivityTypes = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('auxiliaries/activity/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar tipo serviço', error);
      toast.error('Erro ao buscar tipo serviço');
    }
  };

  const createActivityType = useCallback(async (data) => {
    try {
      const response = await api.post('auxiliaries/activity/', data, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      toast.success('Função cadastrada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar função:', error);
      toast.error('Erro ao criar função');
    }
  }, [accessToken]);

  const listWorkloads = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.get('auxiliaries/workload/', {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar cargas horárias', error);
    }
  };

  // Listar funcoes pra o diciplina
  const listFunctions = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/functioninunit/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar funções', error);
      toast.error('Erro ao buscar funções');
    }
  };

  // Cadastrar funcao da unidade para o disciplina
  const createFunctionInUnit = async (data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.post('/auxiliaries/functioninunit/', data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      toast.success('Função cadastrada com sucesso');
      return response.data;
    } catch (error) {
      console.log('Erro ao cadastrar função', error);
      toast.error(error?.response?.data?.message || 'Erro ao cadastrar função');
      throw error;
    }
  };

  // Listar sinais particulares
  const listParticularSigns = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      const response = await api.get('auxiliaries/particularsign/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar sinais particulares', error);
      toast.error('Erro ao buscar sinais particulares');
    }
  };

  // Cadastrar sinais particulares
  const createParticularSign = async (data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.post('/auxiliaries/particularsign/', data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      toast.success('Sinal particular cadastrado com sucesso');
      return response.data;
    } catch (error) {
      console.log('Erro ao cadastrar sinal particular', error);
      toast.error(error?.response?.data?.message || 'Erro ao cadastrar sinal particular');
      throw error;
    }
  };

  // Listar faltas diciplinares pra o diciplina
  const listTypeDisciplinaryFaults = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/fault/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar faltas', error);
      toast.error('Erro ao buscar faltas');
    }
  };

  const createTypeDisciplinaryFault = async (data) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.post('/auxiliaries/fault/', data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      toast.success('Falta disciplinar cadastrada com sucesso');
      return response.data;
    } catch (error) {
      console.log('Erro ao cadastrar falta', error);
      toast.error(error?.response?.data?.message || 'Erro ao cadastrar falta');
      throw error;
    }
  };

  // Listar faltas diciplinares pra o diciplina
  const listFormScape = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }

    try {
      const response = await api.get('/auxiliaries/formscape/', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar forma de fulga', error);
      toast.error('Erro ao buscar forma de fulga');
    }
  };

  // Listagens de processos
  // Listar origens
  const listOrigins = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.get('auxiliaries/originentry/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar origens', error);
      toast.error('Erro ao buscar origens');
    }
  };

  // Listar capitulações penais com busca
  const listCriminalCapitulations = async (searchTerm, params = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    const requestParams = {
      limit: 100,
      ...params,
    };

    const normalizedSearch = normalizeSearchText(searchTerm);

    if (normalizedSearch) {
      if (/^[\d./-]+$/.test(normalizedSearch)) {
        requestParams.art = normalizedSearch;
      } else {
        requestParams.typology = capitalizeSearchText(normalizedSearch);
      }
    }

    try {
      const aggregated = [];
      let nextUrl = 'auxiliaries/criminalcapitulation/';
      let nextParams = requestParams;

      while (nextUrl) {
        const response = await api.get(nextUrl, {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: nextParams
        });

        const payload = response?.data || {};
        const results = Array.isArray(payload?.results) ? payload.results : [];
        aggregated.push(...results);

        nextUrl = payload?.next || null;
        nextParams = undefined;
      }

      return aggregated;
    } catch (error) {
      console.error('Erro ao buscar capitulações penais', error);
      toast.error('Erro ao buscar capitulações penais');
      return [];
    }
  };

  // Listar comarcas/varas a partir da tabela de courts
  const listCourts = async (params = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    const headers = { Authorization: `Bearer ${accessToken}` };
    const normalizedParams = { ...params };
    const aggregated = [];

    if (!normalizedParams.limit) {
      normalizedParams.limit = 500;
    }

    try {
      let nextUrl = 'auxiliaries/court/';
      let nextParams = normalizedParams;

      while (nextUrl) {
        const response = await api.get(nextUrl, {
          headers,
          params: nextParams
        });

        const payload = response?.data || {};
        const results = Array.isArray(payload?.results) ? payload.results : [];
        aggregated.push(...results);

        nextUrl = payload?.next || null;
        nextParams = undefined;

        // Em buscas filtradas, uma página costuma bastar e evita chamadas desnecessárias.
        if (params?.district || params?.unit) {
          break;
        }
      }

      return aggregated;
    } catch (error) {
      console.error('Erro ao buscar cortes/comarcas', error);
      toast.error('Erro ao buscar cortes/comarcas');
      return [];
    }
  };

  // Listar natureza da prisão
  const listNatureOfPrisons = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.get('auxiliaries/naturalprision/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar natureza da prisão', error);
      toast.error('Erro ao buscar natureza da prisão');
    }
  };

  // Listar motivos
  const listReasons = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    try {
      const response = await api.get('auxiliaries/reasonforarrest/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar motivos', error);
      toast.error('Erro ao buscar motivos');
    }
  };

  // natureza da criminal com busca
  const listCriminalNature = async (groupId, searchTerm) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    const params = {};
    if (groupId) {
      params.group = groupId;
    }
    if (searchTerm) {
      params.nature = searchTerm;
    }

    try {
      const response = await api.get('auxiliaries/criminalnature/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params
      });

      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar Natureza Criminal', error);
      toast.error('Erro ao buscar Natureza Criminal');
    }
  };

  // Buscar Natureza Criminal por ID
  const getCriminalNatureById = async (id) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      const response = await api.get(`auxiliaries/criminalnature/${id}/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar Natureza Criminal por ID', error);
      toast.error('Erro ao buscar Natureza Criminal por ID');
    }
  };

  // Buscar Capitulação Penal por ID
  const getCriminalCapitulationById = async (id) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    try {
      const response = await api.get(`auxiliaries/criminalcapitulation/${id}/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar Capitulação Penal por ID', error);
      toast.error('Erro ao buscar Capitulação Penal por ID');
    }
  };

  // natureza grupo com busca
  const listNatureGroup = async (searchTerm) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    const params = {};
    if (searchTerm) {
      params.name = searchTerm;
    }

    try {
      const response = await api.get('auxiliaries/naturegroup/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params
      });
      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar Nature Group', error);
      toast.error('Erro ao buscar Nature Group');
    }
  };

  // deficiencias
  const listDeficiencys = async (searchTerm) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    const params = {};
    if (searchTerm) {
      params.name = searchTerm;
    }

    try {
      const response = await api.get('auxiliaries/deficiency/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params
      });
      return response.data.results;
    } catch (error) {
      console.error('Erro ao buscar deficiências', error);
      toast.error('Erro ao buscar deficiências');
    }
  };

  // Listar Especializações
  const listExpertise = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/expertise/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar especializações:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar especializações.');
      return [];
    }
  };

  // Listar respostas (answers) das perguntas
  const listAnswers = async (params = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/answers/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar respostas:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar respostas.');
      return [];
    }
  };

  // Listar nivél de conciencia
  const listConsciousness = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/level_of_consciousness/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar nivél de conciencia:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar nivél de conciencia.');
      return [];
    }

  };

  // Pupilas
  const listPupils = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/pupils/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar Pupilas:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar pupilas.');
      return [];
    }
  };

  // Comunicação
  const listCommunication = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/communication/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar comuniicação:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar comuniicação.');
      return [];
    }
  };

  // Locomoção
  const listLocomotion = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return [];

    try {
      const response = await api.get('/auxiliaries/locomotion/', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar locomoção:', error);
      toast.error(error.response?.data?.message || 'Erro ao listar locomoção.');
      return [];
    }
  };


  return (
    <AuxiliariesContext.Provider value={{
      listCountry,
      listState,
      listCity,
      listTypeFiles,
      listInternalStatus,
      listReligions,
      listProfessions,
      listTypeVisits,
      listTypeVisitors,
      listSocialProgram,
      listFamilySocialProgram,
      listMentalDisorders,
      listDrugs,
      listColorEthnicity,
      listGender,
      listScholarity,
      listSexualOrientation,
      listMaritalStatus,
      listDiagnoses,
      listAllergies,
      listDevicesOrDrains,
      listSexualInfections,
      listDentitions,
      listProcedures,
      listVisionProblems,
      listScheduling,
      listTypeRelationInternal,
      listTypeVisitor,
      listTypeservicecare,
      listInstitutions,
      createInstitution,
      listActivityTypes,
      createActivityType,
      listWorkloads,
      listFunctions,
      createFunctionInUnit,
      listParticularSigns,
      createParticularSign,
      listTypeDisciplinaryFaults,
      createTypeDisciplinaryFault,
      listRemedies,
      createRemedy,
      listVaccinations,
      listFormScape,
      listOrigins,
      getSchedulingById,
      listCourts,
      listCriminalCapitulations,
      listNatureOfPrisons,
      listReasons,
      listCriminalNature,
      getCriminalNatureById,
      getCriminalCapitulationById,
      listNatureGroup,
      listTypeExam,
      listTypeTest,
      listDeficiencys,
      listExpertise,
      listAnswers,
      listConsciousness,
      listPupils,
      listCommunication,
      listLocomotion
    }}>
      {children}
    </AuxiliariesContext.Provider>
  );
}
